import React, { useRef, useState } from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import { create_paypal_subscription, refresh_subscription } from '../../../api/subscriptionRequests';
import { useHistory } from 'react-router-dom';
import { useAccount } from '../../../context/AccountContext';

// Renders errors or successfull transactions on the screen.
function Message({ content }) {
  return <p>{content}</p>;
}

const PayPal = ({ payment_terms, quantity }) => {
  const quantityRef = useRef(quantity); // Initialize the ref with the quantity prop
  quantityRef.current = quantity; // Always update the ref value to the current quantity
  const initialOptions = {
    // 'client-id': 'AdaveMfVtHyPy-VqBZLIPNV6MiE_Ln31Op0YCxUzynb8wOH7nfURrw1LWIq-CF-njDqmN3Fkaw28Cf9j',
    'client-id':'ARw7LV6RWqgRZEMCJ4jB_6Qyga5Cs121ULuE8P1Pc7ULpbSJ-kcIcmM38g9x9i5udi_6rEtrk-8HA4Ay',
    'enable-funding': 'paylater,card',
    'disable-funding': '',
    'data-sdk-integration-source': 'integrationbuilder_sc',
    vault: 'true',
    intent: 'subscription',
  };
  const { setActivePlan } = useAccount();
  const [message, setMessage] = useState('');
  const history = useHistory();

  console.log(quantity);
  return (
    <div className='App'>
      <PayPalScriptProvider options={initialOptions}>
        <PayPalButtons
          style={{
            shape: 'rect',
            layout: 'vertical',
          }}
          createSubscription={async () => {
            try {
              const plan = 'pro'; // Example, adjust as needed
              console.log(quantity);
              const response = await create_paypal_subscription(plan, payment_terms, quantityRef.current);

              const data = response.data; // With Axios, the response data is accessed via `data` property
              if (data?.id) {
                setMessage(`Successful subscription...`);
                return data.id;
              } else {
                console.error(
                  { callback: 'createSubscription', serverResponse: data },
                  JSON.stringify(data, null, 2),
                );
                // (Optional) The following hides the button container and shows a message about why checkout can't be initiated
                const errorDetail = data?.details?.[0];
                setMessage(
                  `Could not initiate PayPal Subscription...<br><br>${
                    errorDetail?.issue || ''
                  } ${errorDetail?.description || data?.message || ''} ` +
                  (data?.debug_id ? `(${data.debug_id})` : ''),
                  { hideButtons: true },
                );
              }
            } catch (error) {
              console.error(error);
              setMessage(`Could not initiate PayPal Subscription...${error}`);
            }
          }}
          onApprove={async (data, actions) => {
            /*
              No need to activate manually since SUBSCRIBE_NOW is being used.
              Learn how to handle other user actions from our docs:
              https://developer.paypal.com/docs/api/subscriptions/v1/#subscriptions_create
            */
            if (data.orderID) {
              setMessage(
                `You have successfully subscribed to the plan. Your subscription id is: ${data.subscriptionID}`,
              );
              const subscription = await refresh_subscription(data.subscriptionID);

              setActivePlan(subscription.data);
              history.push('/home/get-started');

            } else {
              setMessage(
                `Failed to activate the subscription: ${data.subscriptionID}`,
              );
            }
          }}
        />
      </PayPalScriptProvider>
      <Message content={message} />
    </div>
  );
};

export default PayPal;
